var map = {
	"./contact-me/abdalrahman-shatou.vcf": 4538,
	"./cv/cv.pdf": 8609,
	"./education/acsd.pdf": 6139,
	"./education/acsm.pdf": 7410,
	"./education/aws-aib.pdf": 2266,
	"./education/aws-aif.pdf": 9095,
	"./education/aws-cp.pdf": 6242,
	"./education/aws-dop.pdf": 8557,
	"./education/aws-dva.pdf": 6289,
	"./education/aws-saa.pdf": 9511,
	"./education/az-900.pdf": 5043,
	"./education/ckad.pdf": 6140,
	"./education/coursera-digital-marketing.pdf": 1685,
	"./education/coursera-interaction-design.pdf": 2089,
	"./education/cspo.pdf": 3146,
	"./education/faculty_transcript_en.pdf": 7067,
	"./education/gcp-cdl.pdf": 7774,
	"./education/istqb-agile-tester.pdf": 4831,
	"./education/istqb-genai.pdf": 2219,
	"./education/istqb-test-manager.pdf": 4853,
	"./education/mba_transcript_en.pdf": 3356,
	"./testimonials/letter-aqarmap.pdf": 7900,
	"./testimonials/letter-areeb.pdf": 7619,
	"./testimonials/letter-asgatech.jpg": 4094,
	"./testimonials/letter-ibm.jpg": 5912,
	"./testimonials/letter-medsconnect.pdf": 4757,
	"./testimonials/letter-youxel.jpg": 7613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7292;